import { lazy } from "react";
import { OUTDOOR_INTERESTS } from "../../../shared/outdoors";
import type { WidgetDefinition } from "../types";

export type OutThereConfig = Record<string, never>;

// The report runs astronomy-engine (sun, moon, solunar), so it loads only when this card is on screen.
const OutThereView = lazy(() => import("./OutThereView"));

export const outThereWidget: WidgetDefinition<OutThereConfig> = {
  type: "out-there",
  version: 1,
  name: "Out there",
  description: `Today read through your outdoor interests (${OUTDOOR_INTERESTS.map((i) => i.label.toLowerCase()).join(", ")}): trail mud from the last three days of rain, storm timing above treeline, legal shooting light and wind, solunar periods, water and barometer.`,
  icon: "hiker",
  category: "weather",
  defaultSize: { w: 3, h: 8 },
  minSize: { w: 3, h: 4 },
  stackHeight: 780,
  defaults: {},
  settings: [],
  provider: "nws",
  capabilities: { requiresLocation: true },
  supportsFullscreen: true,
  Component: OutThereView,
};
